export { DefaultDerivedStateProvider } from "@bitwarden/state";
